// Video Slider

$(document).ready(function () {
  // Check if the screen size is mobile (max-width 767px)
  if ($(window).width() <= 767) {
    $(".flavor-carousel").slick({
      slidesToShow: 1, // Show 1 slide on mobile
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      dots: false,
      prevArrow:
        '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
      responsive: [
        {
          breakpoint: 480, // Adjust to 480px for very small mobile devices
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  }
});
